import React, { useState } from "react";

import { PatentSearchFilterType } from "@/components/business/PatentContainer/patentList.types";

import { PATENT_LIST_EDITOR_INFO_FILTER } from "./components/PatentEditorInfoSearch/constants/editorInfoFilter.constants";
import CtgListEditorInfoSearch from "./components/PatentEditorInfoSearch/PatentEditorInfoSearch";
import { PATENT_LIST_INFO_FILTER } from "./components/PatentPressInfoSearch/constants/pressInfoFilter.constants";
import CtgListPressInfoSearch from "./components/PatentPressInfoSearch/PatentPressInfoSearch";
import * as S from "./PatentSearch.style";

const PatentSearch = () => {
  const [currentPatentFilter, setCurrentPatentFilter] =
    useState<PatentSearchFilterType>(PATENT_LIST_INFO_FILTER[0]);
  const [currentEditorFilter, setCurrentEditorFilter] =
    useState<PatentSearchFilterType>(PATENT_LIST_EDITOR_INFO_FILTER[0]);

  return (
    <S.SearchWrapper>
      <CtgListPressInfoSearch
        currentPressFilter={currentPatentFilter}
        setCurrentFilter={setCurrentPatentFilter}
      />
      <CtgListEditorInfoSearch
        currentEditorFilter={currentEditorFilter}
        setCurrentFilter={setCurrentEditorFilter}
      />
    </S.SearchWrapper>
  );
};

export default PatentSearch;
